<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">


      <Form ref="produitForm" @submit="addProduitRestreint" :validation-schema="produitRestreintSchema">
        <div class="row">

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Type de restriction <span class="text-danger">*</span>
              </label>
              <Field name="restriction_type" v-slot="{ field }">
                <Multiselect :options="restrictionTypeOptions" :searchable="true" track-by="value" label="label"
                  v-bind="field" placeholder="Sélectionner le type de restriction" />
              </Field>
              <ErrorMessage name="restriction_type" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Pays <span class="text-danger">*</span>
              </label>
              <Field name="pays" v-slot="{ field }">
                <Multiselect :options="paysOptions" :searchable="true" track-by="value" label="label" v-bind="field"
                  placeholder="Sélectionner le pays" />
              </Field>
            </div>
            <ErrorMessage name="pays" class="text-danger" />
          </div>

          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Description <span class="text-danger">*</span>
              </label>
              <Field 
                name="description" 
                as="textarea" 
                rows="2"
                class="form-control shadow-none fs-md-15 text-black"
                placeholder="Description..." 
              />

              <ErrorMessage name="description" class="text-danger" />
            </div>
          </div>
          
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Type de document
              </label>
              <Field name="typeD" v-slot="{ field }">
                <Multiselect :options="typeDOptions" :searchable="true" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner le type de document" />
              </Field>
            </div>
            <ErrorMessage name="typeD" class="text-danger" />
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Hs Code
              </label>
              <Field name="hscode" v-slot="{ field }">
                <Multiselect :options="hscodeOptions" :searchable="true" track-by="value" label="label" v-bind="field"
                  placeholder="Sélectionner le hscode" />
              </Field>
            </div>
            <ErrorMessage name="hscode" class="text-danger" />
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Catégorie Produit
              </label>
              <Field name="categorieProduit" v-slot="{ field }">
                <Multiselect :options="categorieProduitOptions" :searchable="true" track-by="value" label="label"
                  v-bind="field" placeholder="Sélectionner la categorie de Produit" />
              </Field>
            </div>
            <ErrorMessage name="categorieProduit" class="text-danger" />
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Régime Douanier
              </label>
              <Field name="regimeDouanier" v-slot="{ field }">
                <Multiselect :options="regimeDouanierOptions" :searchable="true" track-by="value" label="label"
                  v-bind="field" placeholder="Sélectionner le régime" />
              </Field>
            </div>
            <ErrorMessage name="regimeDouanier" class="text-danger" />
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Quantité maximale</label>
              <Field name="max_quantity" type="number" class="form-control" placeholder="Quantité maximale autorisée" />
              <ErrorMessage name="max_quantity" class="text-danger" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Valeur maximale</label>
              <Field name="max_declared_value" type="number" class="form-control"
                placeholder="Valeur maximale autorisée" />
              <ErrorMessage name="max_declared_value" class="text-danger" />
            </div>
          </div>
          
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de début d’application de cette restriction.
              </label>
              <Field name="effective_from" type="date" class="form-control shadow-none fs-md-15 text-black" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de fin d’application éventuelle
              </label>
              <Field name="effective_to" type="date" class="form-control shadow-none fs-md-15 text-black" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">Activer</label>
              <Field name="is_active" type="checkbox" class="form-check-input" :value="true" :unchecked-value="false" />
              <ErrorMessage name="is_active" class="text-danger" />
            </div>
          </div>

          <div class="col-md-12">
            <div class="d-flex align-items-center ">
              <button
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit">
                Ajouter un produit
              </button>
              <router-link to="/listeProduitRestreint" class=" btn btn-danger transition border-0 lh-1 fw-medium"><i
                  class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRouter } from "vue-router";
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import axios from 'axios';
import Multiselect from '@vueform/multiselect'
import { Rule } from '@/models/Rule';
import { ProduitRestreint } from '@/models/ProduitRestreint';

export default defineComponent({
  name: "AddProduitRestreint",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  setup: () => {
    const produitRestreintSchema = Yup.object().shape({
      hscode: Yup.string().notRequired(),
      categorieProduit: Yup.string().notRequired(),
      pays: Yup.string().required("Le pays est obligatoire"),
      regimeDouanier: Yup.string().notRequired(),
      description: Yup.string().required("La description est obligatoire"),
      typeD: Yup.string().notRequired(),
      is_active: Yup.boolean(),
      max_quantity: Yup.number().nullable(),
      max_declared_value: Yup.number().nullable(),
      restriction_type: Yup.string().required("Le type de restriction est obligatoire"),
      effective_from: Yup.date().nullable(),
      effective_to: Yup.date().nullable(),
    });
    const produitForm = ref<ProduitRestreint | null>(null);
    const paysOptions = ref([]);
    const hscodeOptions = ref([]);
    const categorieProduitOptions = ref([]);
    const regimeDouanierOptions = ref([]);
    const typeDOptions = ref([]);
    const router = useRouter();


    const restrictionTypeOptions = [
      { value: 'FORBIDDEN', label: 'Interdit' },
      { value: 'LICENSE_REQUIRED', label: 'Licence requise' },
      { value: 'SPECIAL_TAX', label: 'Taxe spéciale' },
      { value: 'QUOTA_LIMITED', label: 'Quantité limitée' },
    ];



    const fetchTypeDocument = async () => {
      try {
        const response = await ApiService.get('/typeDocumentBescs');
        const typeData = response.data.data.data;
        console.log("typeD", typeData);
        typeDOptions.value = typeData.map((typeD) => ({
          value: typeD.id,
          label: `${typeD.code} - ${typeD.libelle} `,
        }));
      } catch (error) {
        //
      }
    };

    const fetchRegimeDouanier = async () => {
      try {
        const response = await ApiService.get('/regimes');
        const regimeDouanierData = response.data.data.data;
        console.log("regimeDouanierData", regimeDouanierData);
        regimeDouanierOptions.value = regimeDouanierData.map((cat) => ({
          value: cat.id,
          label: `${cat.code} - ${cat.name} `,
        }));
      } catch (error) {
        //
      }
    };

    const fetchCatProduit = async () => {
      try {
        const response = await ApiService.get('/categProduits');
        const catProduitData = response.data.data.data;
        console.log("catDataaaa", catProduitData);
        categorieProduitOptions.value = catProduitData.map((cat) => ({
          value: cat.id,
          label: `${cat.code} - ${cat.name} `,
        }));
      } catch (error) {
        //
      }
    };

    const fetchHscode = async () => {
      try {
        const response = await ApiService.get('/hscodes');
        const hscodeData = response.data.data.data;
        console.log("hscodeDataaaa", hscodeData);
        hscodeOptions.value = hscodeData.map((hs) => ({
          value: hs.id,
          label: `${hs.code} - ${hs.product} `,
        }));
      } catch (error) {
        //
      }
    };

    const fetchPays = async () => {
      try {
        const response = await ApiService.get('/pays');
        const paysData = response.data.data.data;
        console.log("paysDataaaa", paysData);
        paysOptions.value = paysData.map((p) => ({
          value: p.id,
          label: `${p.name_fr}`,
        }));
      } catch (error) {
        //
      }
    };

    const addProduitRestreint = async (values, { resetForm }) => {
      const dataToSend = {
        ...values,
      };
      console.log("dodo", dataToSend);
      ApiService.post("/restricted", dataToSend)
        .then(({ data }) => {
          if (data.code == 201) {
            success(data.message);
            resetForm();
            router.push({ name: "ListeProduitRestreintPage" });
          }
        }).catch(({ response }) => {
          error(response.data.message);
        });
    };



    onMounted(() => {
      fetchPays();
      fetchTypeDocument();
      fetchRegimeDouanier();
      fetchCatProduit();
      fetchHscode();
    })
    return {
      addProduitRestreint,
      produitRestreintSchema,
      produitForm,
      hscodeOptions,
      categorieProduitOptions,
      regimeDouanierOptions,
      typeDOptions,
      paysOptions,
      restrictionTypeOptions


    };
  },
});
</script>